import { render, staticRenderFns } from "./BlockRepeater.vue?vue&type=template&id=41cd6dee"
import script from "./BlockRepeater.vue?vue&type=script&lang=js"
export * from "./BlockRepeater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports